export const WORKSPACES_LIST_SUCCESS = 'WORKSPACES_LIST_SUCCESS';
export const WORKSPACES_LIST_ERROR = 'WORKSPACES_LIST_ERROR';
export const WORKSPACES_LIST_REQUEST = 'WORKSPACES_LIST_REQUEST';

export const WORKSPACES_TEAM_MEMBER_SUCCESS = 'WORKSPACES_TEAM_MEMBER_SUCCESS';
export const WORKSPACES_TEAM_MEMBER_ERROR = 'WORKSPACES_TEAM_MEMBER_ERROR';
export const WORKSPACES_TEAM_MEMBER_REQUEST = 'WORKSPACES_TEAM_MEMBER_REQUEST';

export const WORKSPACES_CREATE_SUCCESS = 'WORKSPACES_CREATE_SUCCESS';
export const WORKSPACES_CREATE_ERROR = 'WORKSPACES_CREATE_ERROR';
export const WORKSPACES_CREATE_REQUEST = 'WORKSPACES_CREATE_REQUEST';

export const WORKSPACES_DETAILS_SUCCESS = 'WORKSPACES_DETAILS_SUCCESS';
export const WORKSPACES_DETAILS_ERROR = 'WORKSPACES_DETAILS_ERROR';
export const WORKSPACES_DETAILS_REQUEST = 'WORKSPACES_DETAILS_REQUEST';

export const WORKSPACES_FOLDER_CREATE_SUCCESS =
    'WORKSPACES_FOLDER_CREATE_SUCCESS';
export const WORKSPACES_FOLDER_CREATE_ERROR = 'WORKSPACES_FOLDER_CREATE_ERROR';
export const WORKSPACES_FOLDER_CREATE_REQUEST =
    'WORKSPACES_FOLDER_CREATE_REQUEST';

export const WORKSPACES_FOLDERLIST_SUCCESS = 'WORKSPACES_FOLDERLIST_SUCCESS';
export const WORKSPACES_FOLDERLIST_ERROR = 'WORKSPACES_FOLDERLIST_ERROR';
export const WORKSPACES_FOLDERLIST_REQUEST = 'WORKSPACES_FOLDERLIST_REQUEST';

export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_CLEAR';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_SUCCESS';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_ERROR';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_REQUEST';

export const WORKSPACES_OUTPUT_TEMPLATE_FOLDER_CREATE_SUCCESS =
    'WORKSPACES_OUTPUT_TEMPLATE_CREATE_FOLDER_SUCCESS';
export const WORKSPACES_OUTPUT_TEMPLATE_FOLDER_CREATE_ERROR =
    'WORKSPACES_OUTPUT_TEMPLATE_CREATE_FOLDER_ERROR';
export const WORKSPACES_OUTPUT_TEMPLATE_FOLDER_CREATE_REQUEST =
    'WORKSPACES_OUTPUT_TEMPLATE_CREATE_FOLDER_REQUEST';

export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_SUCCESS =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_SUCCESS';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_ERROR =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_ERROR';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_REQUEST =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_LIST_REQUEST';

export const WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_SUCCESS =
    'WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_SUCCESS';
export const WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_ERROR =
    'WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_ERROR';
export const WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_REQUEST =
    'WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_REQUEST';

export const WORKSPACES_SUPPORT_DOCUMENTSLIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTSLIST_SUCCESS';
export const WORKSPACES_SUPPORT_DOCUMENTSLIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTSLIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTSLIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTSLIST_REQUEST';

export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_SUCCESS';
export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_LIST_REQUEST';

export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_SUCCESS';
export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTS_DATA_DETAILS_OUT_PUT_LIST_REQUEST';

export const WORKSPACES_QUICKLIST_ERROR = 'WORKSPACES_QUICKLIST_ERROR';
export const WORKSPACES_QUICKLIST_REQUEST = 'WORKSPACES_QUICKLIST_REQUEST';
export const WORKSPACES_QUICKLIST_SUCCESS = 'WORKSPACES_QUICKLIST_SUCCESS';

export const DASHBOARD_QUICK_ACTIONS_CREATED_ERROR =
    'DASHBOARD_QUICK_ACTIONS_CREATED_ERROR';
export const DASHBOARD_QUICK_ACTIONS_CREATED_REQUEST =
    'DASHBOARD_QUICK_ACTIONS_CREATED_REQUEST';
export const DASHBOARD_QUICK_ACTIONS_CREATED_SUCCESS =
    'DASHBOARD_QUICK_ACTIONS_CREATED_SUCCESS';

export const DASHBOARD_TIME_CREATED_ERROR = 'DASHBOARD_TIME_CREATED_ERROR';
export const DASHBOARD_TIME_CREATED_REQUEST = 'DASHBOARD_TIME_CREATED_REQUEST';
export const DASHBOARD_TIME_CREATED_SUCCESS = 'DASHBOARD_TIME_CREATED_SUCCESS';

export const DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_ERROR =
    'DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_ERROR';
export const DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_REQUEST =
    'DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_REQUEST';
export const DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_SUCCESS =
    'DASHBOARD_RECENTLY_USED_QUICK_ACTIONS_SUCCESS';

export const DASHBOARD_PUBLIC_QUICK_ACTIONS_ERROR =
    'DASHBOARD_PUBLIC_QUICK_ACTIONS_ERROR';
export const DASHBOARD_PUBLIC_QUICK_ACTIONS_REQUEST =
    'DASHBOARD_PUBLIC_QUICK_ACTIONS_REQUEST';
export const DASHBOARD_PUBLIC_QUICK_ACTIONS_SUCCESS =
    'DASHBOARD_PUBLIC_QUICK_ACTIONS_SUCCESS';

export const DASHBOARD_TEAM_MEMBERS_ERROR = 'DASHBOARD_TEAM_MEMBERS_ERROR';
export const DASHBOARD_TEAM_MEMBERS_REQUEST = 'DASHBOARD_TEAM_MEMBERS_REQUEST';
export const DASHBOARD_TEAM_MEMBERS_SUCCESS = 'DASHBOARD_TEAM_MEMBERS_SUCCESS';

export const BUILD_QUICK_ACTION_SUCCESS = 'BUILD_QUICK_ACTION_SUCCESS';
export const BUILD_QUICK_ACTION_ERROR = 'BUILD_QUICK_ACTION_ERROR';
export const BUILD_QUICK_ACTION_REQUEST = 'BUILD_QUICK_ACTION_REQUEST';

export const BUILD_QUICK_ACTION_UPDATE_SUCCESS =
    'BUILD_QUICK_ACTION_UPDATE_SUCCESS';
export const BUILD_QUICK_ACTION_UPDATE_ERROR =
    'BUILD_QUICK_ACTION_UPDATE_ERROR';
export const BUILD_QUICK_ACTION_UPDATE_REQUEST =
    'BUILD_QUICK_ACTION_UPDATE_REQUEST';

export const BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_SUCCESS =
    'BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_SUCCESS';
export const BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_ERROR =
    'BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_ERROR';
export const BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_REQUEST =
    'BUILD_ACTION_SUPPORTING_DOCUMENT_QUICK_RUN_REQUEST';

export const BUILD_QUICK_ACTION_COPY_SUCCESS =
    'BUILD_QUICK_ACTION_COPY_SUCCESS';
export const BUILD_QUICK_ACTION_COPY_ERROR = 'BUILD_QUICK_ACTION_COPY_ERROR';
export const BUILD_QUICK_ACTION_COPY_REQUEST =
    'BUILD_QUICK_ACTION_COPY_REQUEST';

export const GET_USER_SUPPORTING_DOCUMENT_SUCCESS =
    'GET_USER_SUPPORTING_DOCUMENT_SUCCESS';
export const GET_USER_SUPPORTING_DOCUMENT_ERROR =
    'GET_USER_SUPPORTING_DOCUMENT_ERROR';
export const GET_USER_SUPPORTING_DOCUMENT_REQUEST =
    'GET_USER_SUPPORTING_DOCUMENT_REQUEST';

export const GET_USER_OUTPUT_FORMAT_SUCCESS = 'GET_USER_OUTPUT_FORMAT_SUCCESS';
export const GET_USER_OUTPUT_FORMAT_ERROR = 'GET_USER_OUTPUT_FORMAT_ERROR';
export const GET_USER_OUTPUT_FORMAT_REQUEST = 'GET_USER_OUTPUT_FORMAT_REQUEST';
export const DASHBOARD_BOOKMARKED_QUICK_ACTIONS_ERROR =
    'DASHBOARD_BOOKMARKED_QUICK_ACTIONS_ERROR';
export const DASHBOARD_BOOKMARKED_QUICK_ACTIONS_REQUEST =
    'DASHBOARD_BOOKMARKED_QUICK_ACTIONS_REQUEST';
export const DASHBOARD_BOOKMARKED_QUICK_ACTIONS_SUCCESS =
    'DASHBOARD_BOOKMARKED_QUICK_ACTIONS_SUCCESS';

//Resources

export const CREATE_VIDEO_GUIDE_SUCCESS = 'REATE_VIDEO_GUIDE_SUCCESS';
export const CREATE_VIDEO_GUIDE_ERROR = 'REATE_VIDEO_GUIDE_ERROR';
export const CREATE_VIDEO_GUIDE_REQUEST = 'REATE_VIDEO_GUIDE_REQUEST';

export const LIST_VIDEO_GUIDE_SUCCESS = 'LIST_VIDEO_GUIDE_SUCCESS';
export const LIST_VIDEO_GUIDE_ERROR = 'REATE_VIDEO_GUIDE_ERROR';
export const LIST_VIDEO_GUIDE_REQUEST = 'REATE_VIDEO_GUIDE_REQUEST';

export const DELETE_VIDEO_GUIDE_SUCCESS = 'DELETE_VIDEO_GUIDE_SUCCESS';
export const DELETE_VIDEO_GUIDE_ERROR = 'DELETE_VIDEO_GUIDE_ERROR';
export const DELETE_VIDEO_GUIDE_REQUEST = 'DELETE_VIDEO_GUIDE_REQUEST';

//ROLES AND PERMISSION
export const USER_MANAGEMENT_ROLES_SUCCESS = 'USER_MANAGEMENT_ROLES_SUCCESS';
export const USER_MANAGEMENT_ROLES_ERROR = 'USER_MANAGEMENT_ROLES_ERROR';
export const USER_MANAGEMENT_ROLES_REQUEST = 'USER_MANAGEMENT_ROLES_REQUEST';

export const USER_MANAGEMENT_ROLES_LIST_SUCCESS =
    'USER_MANAGEMENT_ROLES_LIST_SUCCESS';
export const USER_MANAGEMENT_ROLES_LIST_ERROR =
    'USER_MANAGEMENT_ROLES_LIST_ERROR';
export const USER_MANAGEMENT_ROLES_LIST_REQUEST =
    'USER_MANAGEMENT_ROLES_LIST_REQUEST';

export const USER_MANAGEMENT_ROLES_CREATE_SUCCESS =
    'USER_MANAGEMENT_ROLES_CREATE_SUCCESS';
export const USER_MANAGEMENT_ROLES_CREATE_ERROR =
    'USER_MANAGEMENT_ROLES_CREATE_ERROR';
export const USER_MANAGEMENT_ROLES_CREATE_REQUEST =
    'USER_MANAGEMENT_ROLES_CREATE_REQUEST';

export const USER_MANAGEMENT_ROLES_UPDATE_SUCCESS =
    'USER_MANAGEMENT_ROLES_UPDATE_SUCCESS';
export const USER_MANAGEMENT_ROLES_UPDATE_ERROR =
    'USER_MANAGEMENT_ROLES_UPDATE_ERROR';
export const USER_MANAGEMENT_ROLES_UPDATE_REQUEST =
    'USER_MANAGEMENT_ROLES_UPDATE_REQUEST';

export const WORKSPACES_QUICKACTIONSLIST_SUCCESS =
    'WORKSPACES_QUICKACTIONSLIST_SUCCESS';
export const WORKSPACES_QUICKACTIONSLIST_ERROR =
    'WORKSPACES_QUICKACTIONSLIST_ERROR';
export const WORKSPACES_QUICKACTIONSLIST_REQUEST =
    'WORKSPACES_QUICKACTIONSLIST_REQUEST';

export const WORKSPACE_BOOKMARK_TOGGLE_SUCCESS =
    'WORKSPACE_BOOKMARK_TOGGLE_SUCCESS';
export const WORKSPACE_BOOKMARK_TOGGLE_ERROR =
    'WORKSPACE_BOOKMARK_TOGGLE_ERROR';
export const WORKSPACE_BOOKMARK_TOGGLE_REQUEST =
    'WORKSPACE_BOOKMARK_TOGGLE_REQUEST';

export const QUICK_ACTION_COPY_ERROR = 'QUICK_ACTION_COPY_ERROR';
export const QUICK_ACTION_COPY_REQUEST = 'QUICK_ACTION_COPY_REQUEST';
export const QUICK_ACTION_COPY_SUCCESS = 'QUICK_ACTION_COPY_SUCCESS';

export const EDIT_VIDEO_GUIDE_SUCCESS = 'EDIT_VIDEO_GUIDE_SUCCESS';
export const EDIT_VIDEO_GUIDE_ERROR = 'EDIT_VIDEO_GUIDE_ERROR';
export const EDIT_VIDEO_GUIDE_REQUEST = 'EDIT_VIDEO_GUIDE_REQUEST';

export const PRODUCTS_ERROR = 'PRODUCTS_ERROR';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_REQUEST = 'PRODUCTS_REQUEST';

export const PRODUCTS_PLAN_ERROR = 'PRODUCTS_PLAN_ERROR';
export const PRODUCTS_PLAN_SUCCESS = 'PRODUCTS_PLAN_SUCCESS';
export const PRODUCTS_PLAN_REQUEST = 'PRODUCTS_PLAN_REQUEST';

export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_REQUEST';
export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_DATA_LIST_SUCCESS';

export const SUPPORTING_DOCUMENT_UPDATE_ERROR =
    'SUPPORTING_DOCUMENT_UPDATE_ERROR';
export const SUPPORTING_DOCUMENT_UPDATE_REQUEST =
    'SUPPORTING_DOCUMENT_UPDATE_REQUEST';
export const SUPPORTING_DOCUMENT_UPDATE_SUCCESS =
    'SUPPORTING_DOCUMENT_UPDATE_SUCCESS';

export const CLEAR_DOCUMENTS_SUPPORTING_DATA =
    'CLEAR_DOCUMENTS_SUPPORTING_DATA';

export const WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_REQUEST';
export const WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTS_OUTPUT_EDIT_DATA_LIST_SUCCESS';

export const SUPPORTING_DOCUMENT_OUTPUT_UPDATE_ERROR =
    'SUPPORTING_DOCUMENT_OUTPUT_UPDATE_ERROR';
export const SUPPORTING_DOCUMENT_OUTPUT_UPDATE_REQUEST =
    'SUPPORTING_DOCUMENT_OUTPUT_UPDATE_REQUEST';
export const SUPPORTING_DOCUMENT_OUTPUT_UPDATE_SUCCESS =
    'SUPPORTING_DOCUMENT_OUTPUT_UPDATE_SUCCESS';

export const NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
export const NOTIFICATIONS_REQUEST = 'NOTIFICATIONS_REQUEST';

export const SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS =
    'SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS';
export const SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR =
    'SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR';
export const SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST =
    'SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST';
export const SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR =
    'SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR';

export const DOCUMENTS_SUPPORTING_CREATE_SUCCESS =
    'DOCUMENTS_SUPPORTING_CREATE_SUCCESS';
export const DOCUMENTS_SUPPORTING_CREATE_ERROR =
    'DOCUMENTS_SUPPORTING_CREATE_ERROR';
export const DOCUMENTS_SUPPORTING_CREATE_REQUEST =
    'DOCUMENTS_SUPPORTING_CREATE_REQUEST';

export const DOCUMENTS_SUPPORTING_OUTPUT_CREATE_SUCCESS =
    'DOCUMENTS_SUPPORTING_OUTPUT_CREATE_SUCCESS';
export const DOCUMENTS_SUPPORTING_OUTPUT_CREATE_ERROR =
    'DOCUMENTS_SUPPORTING_OUTPUT_CREATE_ERROR';
export const DOCUMENTS_SUPPORTING_OUTPUT_CREATE_REQUEST =
    'DOCUMENTS_SUPPORTING_OUTPUT_CREATE_REQUEST';

export const SUPPORTING_DOCUMENTS_FILE_UPLOAD_ERROR =
    'SUPPORTING_DOCUMENTS_FILE_UPLOAD_ERROR';
export const SUPPORTING_DOCUMENTS_FILE_UPLOAD_REQUEST =
    'SUPPORTING_DOCUMENTS_FILE_UPLOAD_REQUEST';
export const SUPPORTING_DOCUMENTS_FILE_UPLOAD_SUCCESS =
    'SUPPORTING_DOCUMENTS_FILE_UPLOAD_SUCCESS';
    export const SUPPORTING_DOCUMENTS_FILE_UPLOAD_CLEAR =
    'SUPPORTING_DOCUMENTS_FILE_UPLOAD_CLEAR';

export const WORKSPACE_ACCESS_ERROR = 'WORKSPACE_ACCESS_ERROR';
export const WORKSPACE_ACCESS_SUCCESS = 'WORKSPACE_ACCESS_SUCCESS';
export const WORKSPACE_ACCESS_REQUEST = 'WORKSPACE_ACCESS_REQUEST';

export const SETTING_WORKSPACE_ANALYTICS_ERROR =
    'SETTING_WORKSPACE_ANALYTICS_ERROR';
export const SETTING_WORKSPACE_ANALYTICS_SUCCESS =
    'SETTING_WORKSPACE_ANALYTICS_SUCCESS';
export const SETTING_WORKSPACE_ANALYTICS_REQUEST =
    'SETTING_WORKSPACE_ANALYTICS_REQUEST';

export const SETTINGS_WORKSPACE_ACCESS_REQUESTS_ERROR =
    'SETTINGS_WORKSPACE_ACCESS_REQUESTS_ERROR';
export const SETTINGS_WORKSPACE_ACCESS_REQUESTS_SUCCESS =
    'SETTINGS_WORKSPACE_ACCESS_REQUESTS_SUCCESS';
export const SETTINGS_WORKSPACE_ACCESS_REQUESTS_REQUEST =
    'SETTINGS_WORKSPACE_ACCESS_REQUESTS_REQUEST';

export const SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_ERROR =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_ERROR';
export const SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_SUCCESS =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_SUCCESS';
export const SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_REQUEST =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_REQUEST';

export const EDIT_CHANGE_PASSWORD_SUCCESS = 'EDIT_CHANGE_PASSWORD_SUCCESS';
export const EDIT_CHANGE_PASSWORD_ERROR = 'EDIT_CHANGE_PASSWORD_ERROR';
export const EDIT_CHANGE_PASSWORD_REQUEST = 'EDIT_CHANGE_PASSWORD_REQUEST';

export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_ERROR = 'EDIT_PROFILE_ERROR';
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';

export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';
export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';

export const MFASETTINGS_QR_VERIFY_SUCCESS = 'MFASETTINGS_QR_VERIFY_SUCCESS';
export const MFASETTINGS_QR_VERIFY_ERROR = 'MFASETTINGS_QR_VERIFY_ERROR';
export const MFASETTINGS_QR_VERIFY_REQUEST = 'MFASETTINGS_QR_VERIFY_REQUEST';

export const MFASETTINGS_SUCCESS = 'MFASETTINGS_SUCCESS';
export const MFASETTINGS_ERROR = 'MFASETTINGS_ERROR';
export const MFASETTINGS_REQUEST = 'MFASETTINGS_REQUEST';

export const NOTIFICATIONS_READ_ERROR = 'NOTIFICATIONS_READ_ERROR';
export const NOTIFICATIONS_READ_SUCCESS = 'NOTIFICATIONS_READ_SUCCESS';
export const NOTIFICATIONS_READ_REQUEST = 'NOTIFICATIONS_READ_REQUEST';

export const NOTIFICATIONS_READ_All_ERROR = 'NOTIFICATIONS_READ_All_ERROR';
export const NOTIFICATIONS_READ_All_SUCCESS = 'NOTIFICATIONS_READ_All_SUCCESS';
export const NOTIFICATIONS_READ_All_REQUEST = 'NOTIFICATIONS_READ_All_REQUEST';

export const BUILD_QUICK_ACTION_BY_ID_SUCCESS =
    'BUILD_QUICK_ACTION_BY_ID_SUCCESS';
export const BUILD_QUICK_ACTION_BY_ID_ERROR = 'BUILD_QUICK_ACTION_BY_ID_ERROR';
export const BUILD_QUICK_ACTION_BY_ID_REQUEST =
    'BUILD_QUICK_ACTION_BY_ID_REQUEST';

export const ACCESSS_USER_MANAGEMENT_LIST_SUCCESS =
    'ACCESSS_USER_MANAGEMENT_SUCCESS';
export const ACCESSS_USER_MANAGEMENT_LIST_ERROR =
    'ACCESSS_USER_MANAGEMENT_ERROR';
export const ACCESSS_USER_MANAGEMENT_LIST_REQUEST =
    'ACCESSS_USER_MANAGEMENT_REQUEST';

export const SUBSCRIPTIONS_ERROR = 'SUBSCRIPTIONS_ERROR';
export const SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTIONS_SUCCESS';
export const SUBSCRIPTIONS_REQUEST = 'PRODUCTS_REQUEST';

export const SUBSCRIPTIONS_CANCLE_ERROR = 'SUBSCRIPTIONS_CANCLE_ERROR';
export const SUBSCRIPTIONS_CANCLE_SUCCESS = 'SUBSCRIPTIONS_CANCLE_SUCCESS';
export const SUBSCRIPTIONS_CANCLE_REQUEST = 'SUBSCRIPTIONS_CANCLE_REQUEST';

//RUN_QUICK_BATCH
export const RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS =
    'RUN_QUICK_ACTION_UPLOAD_FILE_SUCCESS';
export const RUN_QUICK_ACTION_UPLOAD_FILE_ERROR =
    'RUN_QUICK_ACTION_UPLOAD_FILE_ERROR';
export const RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST =
    'RUN_QUICK_ACTION_UPLOAD_FILE_REQUEST';
export const RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS =
    'RUN_QUICK_ACTION_REMOVE_FILE_SUCCESS';
export const RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS =
    'RUN_QUICK_ACTION_REMOVE_ARRAY_SUCCESS';
export const QUICK_ACTION_RUN_STATUS_SUCCESS =
    'QUICK_ACTION_RUN_STATUS_SUCCESS';
export const QUICK_ACTION_RUN_STATUS_ERROR = 'QUICK_ACTION_RUN_STATUS_ERROR';
export const QUICK_ACTION_RUN_STATUS_REQUEST =
    'QUICK_ACTION_RUN_STATUS_REQUEST';

export const QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_SUCCESS =
    'QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_SUCCESS';
export const QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_ERROR =
    'QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_ERROR';
export const QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_REQUEST =
    'QUICK_ACTION_RUN_UPLOAD_FILE_WITH_FILEID_REQUEST';

export const QUICK_ACTION_RUN_GENERATE_CHUNKS_SUCCESS =
    'QUICK_ACTION_RUN_GENERATE_CHUNKS_SUCCESS';
export const QUICK_ACTION_RUN_GENERATE_CHUNKS_ERROR =
    'QUICK_ACTION_RUN_GENERATE_CHUNKS_ERROR';
export const QUICK_ACTION_RUN_GENERATE_CHUNKS_REQUEST =
    'QUICK_ACTION_RUN_GENERATE_CHUNKS_REQUEST';

export const QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_SUCCESS =
    'QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_SUCCESS';
export const QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_ERROR =
    'QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_ERROR';
export const QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_REQUEST =
    'QUICK_ACTION_RUN_SAVE_EXECUTE_BATCH_REQUEST';

export const RUN_QUICK_ACTION_RUN_ID_SUCCESS =
    'RUN_QUICK_ACTION_RUN_ID_SUCCESS';
export const RUN_QUICK_ACTION_RUN_ID_ERROR = 'RUN_QUICK_ACTION_RUN_ID_ERROR';
export const RUN_QUICK_ACTION_RUN_ID_REQUEST =
    'RUN_QUICK_ACTION_RUN_ID_REQUEST';

export const CREATE_PLAY_CHAT_SUCCESS = 'CREATE_PLAY_CHAT_SUCCESS';
export const CREATE_PLAY_CHAT_STREAM = 'CREATE_PLAY_CHAT_STREAM';
export const CREATE_PLAY_CHAT_ERROR = 'CREATE_PLAY_CHAT_ERROR';
export const CREATE_PLAY_CHAT_REQUEST = 'CREATE_PLAY_CHAT_REQUEST';
export const CREATE_PLAY_CHAT_STOP_LOADER = 'CREATE_PLAY_CHAT_STOP_LOADER';

export const CREATE_PLAY_QUERY_SUCCESS = 'CREATE_PLAY_QUERY_SUCCESS';
export const CREATE_PLAY_QUERY_ERROR = 'CREATE_PLAY_QUERY_ERROR';
export const CREATE_PLAY_QUERY_REQUEST = 'CREATE_PLAY_QUERY_REQUEST';
export const CREATE_PLAY_QUERY_STREAM = 'CREATE_PLAY_QUERY_STREAM';
export const CREATE_PLAY_QUERY_STOP_LOADER = 'CREATE_PLAY_QUERY_STOP_LOADER';

export const CREATE_PLAY_QUERY_OPTIONS_SUCCESS =
    'CREATE_PLAY_QUERY_OPTIONS_SUCCESS';
export const CREATE_PLAY_QUERY_OPTIONS_ERROR =
    'CREATE_PLAY_QUERY_OPTIONS_ERROR';
export const CREATE_PLAY_QUERY_OPTIONS_REQUEST =
    'CREATE_PLAY_QUERY_OPTIONS_REQUEST';

export const CREATE_PLAY_QUERY_FOLDERS_SUCCESS =
    'CREATE_PLAY_QUERY_FOLDERS_SUCCESS';
export const CREATE_PLAY_QUERY_FOLDERS_ERROR =
    'CREATE_PLAY_QUERY_FOLDERS_ERROR';
export const CREATE_PLAY_QUERY_FOLDERS_REQUEST =
    'CREATE_PLAY_QUERY_FOLDERS_REQUEST';

export const CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_SUCCESS =
    'CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_SUCCESS';
export const CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_ERROR =
    'CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_ERROR';
export const CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_REQUEST =
    'CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_REQUEST';

export const CREATE_PLAY_QUERY_DATA_LIBRARY_SUCCESS =
    'CREATE_PLAY_QUER_DATA_LIBRARY_SUCCESS';
export const CREATE_PLAY_QUERY_DATA_LIBRARY_ERROR =
    'CREATE_PLAY_QUERY_DATA_LIBRARY_ERROR';
export const CREATE_PLAY_QUERY_DATA_LIBRARY_REQUEST =
    'CREATE_PLAY_QUERY_DATA_LIBRARY_REQUEST';

export const CREATE_PLAY_HISTORY_SUCCESS = 'CREATE_PLAY_HISTORY_SUCCESS';
export const CREATE_PLAY_HISTORY_ERROR = 'CREATE_PLAY_HISTORY_ERROR';
export const CREATE_PLAY_HISTORY_REQUEST = 'CREATE_PLAY_HISTORY_REQUEST';

export const CREATE_PLAY_VIEW_HISTORY_SUCCESS =
    'CREATE_PLAY_VIEW_HISTORY_SUCCESS';
export const CREATE_PLAY_VIEW_HISTORY_ERROR = 'CREATE_PLAY_VIEW_HISTORY_ERROR';
export const CREATE_PLAY_VIEW_HISTORY_REQUEST =
    'CREATE_PLAY_VIEW_HISTORY_REQUEST';

export const SET_CHAT_DOCUMENT = 'SET_CHAT_DOCUMENT';

export const SUPPORTING_DOCUMENT_DELETE_ERROR =
    'SUPPORTING_DOCUMENT_DELETE_ERROR';
export const SUPPORTING_DOCUMENT_DELETE_REQUEST =
    'SUPPORTING_DOCUMENT_DELETE_REQUEST';
export const SUPPORTING_DOCUMENT_DELETE_SUCCESS =
    'SUPPORTING_DOCUMENT_DELETE_SUCCESS';

export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_ERROR =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_ERROR';
export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_REQUEST =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_REQUEST';
export const WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_SUCCESS =
    'WORKSPACES_SUPPORT_DOCUMENTS_EDIT_OUTPUT_LIST_SUCCESS';

export const SUPPORTING_DOCUMENT_OUTPUT_DELETE_ERROR =
    'SUPPORTING_DOCUMENT_OUTPUT_DELETE_ERROR';
export const SUPPORTING_DOCUMENT_OUTPUT_DELETE_REQUEST =
    'SUPPORTING_DOCUMENT_OUTPUT_DELETE_REQUEST';
export const SUPPORTING_DOCUMENT_OUTPUT_DELETE_SUCCESS =
    'SUPPORTING_DOCUMENT_OUTPUT_DELETE_SUCCESS';

export const WORKSPACES_QUICKACTIONSHISTORY_SUCCESS =
    'WORKSPACES_QUICKACTIONSHISTORY_SUCCESS';
export const WORKSPACES_QUICKACTIONSHISTORY_ERROR =
    'WORKSPACES_QUICKACTIONSHISTORY_ERROR';
export const WORKSPACES_QUICKACTIONSHISTORY_REQUEST =
    'WORKSPACES_QUICKACTIONSHISTORY_REQUEST';

export const WORKSPACES_QUICKACTIONSSELF_SUCCESS =
    'WORKSPACES_QUICKACTIONSSELF_SUCCESS';
export const WORKSPACES_QUICKACTIONSSELF_ERROR =
    'WORKSPACES_QUICKACTIONSSELF_ERROR';
export const WORKSPACES_QUICKACTIONSSELF_REQUEST =
    'WORKSPACES_QUICKACTIONSSELF_REQUEST';

export const DASHBOARD_TEAM_ACTIVITY_ERROR = 'DASHBOARD_TEAM_ACTIVITY_ERROR';
export const DASHBOARD_TEAM_ACTIVITY_REQUEST =
    'DASHBOARD_TEAM_ACTIVITY_REQUEST';
export const DASHBOARD_TEAM_ACTIVITY_SUCCESS =
    'DASHBOARD_TEAM_ACTIVITY_SUCCESS';

export const QUICK_ACTION_FOLDER_ERROR = 'QUICK_ACTION_FOLDER_ERROR';
export const QUICK_ACTION_FOLDER_REQUEST = 'QUICK_ACTION_FOLDER_REQUEST';
export const QUICK_ACTION_FOLDER_SUCCESS = 'QUICK_ACTION_FOLDER_SUCCESS';

export const QUICK_ACTION_FOLDER_LIST_ERROR = 'QUICK_ACTION_FOLDER_LIST_ERROR';
export const QUICK_ACTION_FOLDER_LIST_REQUEST =
    'QUICK_ACTION_FOLDER_LIST_REQUEST';
export const QUICK_ACTION_FOLDER_LIST_SUCCESS =
    'QUICK_ACTION_FOLDER_LIST_SUCCESS';

//workspace Role and Permission

export const WORKSPACES_ROLE_PERMISSION_LIST_SUCCESS =
    'WORKSPACES_ROLE_PERMISSION_LIST_SUCCESS';
export const WORKSPACES_ROLE_PERMISSION_LIST_ERROR =
    'WORKSPACES_ROLE_PERMISSION_LIST_ERROR';
export const WORKSPACES_ROLE_PERMISSION_LIST_REQUEST =
    'WORKSPACES_ROLE_PERMISSION_LIST_REQUEST';

export const WORKSPACE_ROLE_PERMISSION_CREATE_SUCCESS =
    'WORKSPACE_ROLE_PERMISSION_CREATE_SUCCESS';
export const WORKSPACE_ROLE_PERMISSION_CREATE_ERROR =
    'WORKSPACE_ROLE_PERMISSION_CREATE_ERROR';
export const WORKSPACE_ROLE_PERMISSION_CREATE_REQUEST =
    'WORKSPACE_ROLE_PERMISSION_CREATE_REQUEST';

export const WORKSPACE_ROLE_PERMISSION_UPDATE_SUCCESS =
    'WORKSPACE_ROLE_PERMISSION_UPDATE_SUCCESS';
export const WORKSPACE_ROLE_PERMISSION_UPDATE_ERROR =
    'WORKSPACE_ROLE_PERMISSION_UPDATE_ERROR';
export const WORKSPACE_ROLE_PERMISSION_UPDATE_REQUEST =
    'WORKSPACE_ROLE_PERMISSION_UPDATE_REQUEST';

export const CREATE_UPLOAD_FAQ_SUCCESS = 'CREATE_UPLOAD_FAQ_SUCCESS';
export const CREATE_UPLOAD_FAQ_ERROR = 'CREATE_UPLOAD_FAQ_ERROR';
export const CREATE_UPLOAD_FAQ_REQUEST = 'CREATE_UPLOAD_FAQ_REQUEST';

export const CREATE_UPLOAD_FAQ_TOPIC_LIST_SUCCESS =
    'CREATE_UPLOAD_FAQ_TOPIC_LIST_SUCCESS';
export const CREATE_UPLOAD_FAQ_TOPIC_LIST_ERROR =
    'CREATE_UPLOAD_FAQ_TOPIC_LIST_ERROR';
export const CREATE_UPLOAD_FAQ_TOPIC_LIST_REQUEST =
    'CREATE_UPLOAD_FAQ_TOPIC_LIST_REQUEST';

export const CREATE_TOPIC_QUESTION_LIST_SUCCESS =
    'CREATE_TOPIC_QUESTION_LIST_SUCCESS';
export const CREATE_TOPIC_QUESTION_LIST_ERROR =
    'CREATE_TOPIC_QUESTION_LIST_ERROR';
export const CREATE_TOPIC_QUESTION_LIST_REQUEST =
    'CREATE_TOPIC_QUESTION_LIST_REQUEST';

export const CREATE_EDIT_FAQ_QUES_LIST_SUCCESS =
    'CREATE_EDIT_FAQ_QUES_LIST_SUCCESS';
export const CREATE_EDIT_FAQ_QUES_LIST_ERROR =
    'CREATE_EDIT_FAQ_QUES_LIST_ERROR';
export const CREATE_EDIT_FAQ_QUES_LIST_REQUEST =
    'CREATE_EDIT_FAQ_QUES_LIST_REQUEST';

export const DELETE_QUES_LIST_SUCCESS = 'DELETE_QUES_LIST_SUCCESS';
export const DELETE_QUES_LIST_ERROR = 'DELETE_QUES_LIST_ERROR';
export const DELETE_QUES_LIST_REQUEST = 'DELETE_QUES_LIST_REQUEST';

export const UPDATE_PARENT_QUES_LIST_SUCCESS =
    'UPDATE_PARENT_QUES_LIST_SUCCESS';
export const UPDATE_PARENT_QUES_LIST_ERROR = 'UPDATE_PARENT_QUES_LIST_ERROR';
export const UPDATE_PARENT_QUES_LIST_REQUEST =
    'UPDATE_PARENT_QUES_LIST_REQUEST';

export const WORKSPACES_USER_CREATE_ERROR = 'WORKSPACES_USER_CREATE_ERROR';
export const WORKSPACES_USER_CREATE_REQUEST = 'WORKSPACES_USER_CREATE_REQUEST';
export const WORKSPACES_USER_CREATE_SUCCESS = 'WORKSPACES_USER_CREATE_SUCCESS';
export const WORKSPACE_ROLE_DELETE_SUCCESS = 'WORKSPACE_ROLE_DELETE_SUCCESS';
export const WORKSPACE_ROLE_DELETE_ERROR = 'WORKSPACE_ROLE_DELETE_ERROR';
export const WORKSPACE_ROLE_DELETE_REQUEST = 'WORKSPACE_ROLE_DELETE_REQUEST';

export const USER_MANAGEMENT_ROLE_DELETE_SUCCESS =
    'USER_MANAGEMENT_ROLE_DELETE_SUCCESS';
export const USER_MANAGEMENT_ROLE_DELETE_ERROR =
    'USER_MANAGEMENT_ROLE_DELETE_ERROR';
export const USER_MANAGEMENT_ROLE_DELETE_REQUEST =
    'USER_MANAGEMENT_ROLE_DELETE_REQUEST';

export const ACCESSS_USER_MANAGEMENT_UPDATE_SUCCESS =
    'ACCESSS_USER_MANAGEMENT_UPDATE_SUCCESS';
export const ACCESSS_USER_MANAGEMENT_UPDATE_ERROR =
    'ACCESSS_USER_MANAGEMENT_UPDATE_ERROR';
export const ACCESSS_USER_MANAGEMENT_UPDATE_REQUEST =
    'ACCESSS_USER_MANAGEMENT_UPDATE_REQUEST';

export const WORKSPACES_OUTPUT_FORMATEID_ERROR =
    'WORKSPACES_OUTPUT_FORMATEID_ERROR';
export const WORKSPACES_OUTPUT_FORMATEID_REQUEST =
    'WORKSPACES_OUTPUT_FORMATEID_REQUEST';
export const WORKSPACES_OUTPUT_FORMATEID_SUCCESS =
    'WORKSPACES_OUTPUT_FORMATEID_SUCCESS';

export const WORKSPACES_SUPPORTINGDOCUMENTID_ERROR =
    'WORKSPACES_SUPPORTINGDOCUMENTID_ERROR';
export const WORKSPACES_SUPPORTINGDOCUMENTID_REQUEST =
    'WORKSPACES_SUPPORTINGDOCUMENTID_REQUEST';
export const WORKSPACES_SUPPORTINGDOCUMENTID_SUCCESS =
    'WORKSPACES_SUPPORTINGDOCUMENTID_SUCCESS';

export const QUICK_ACTION_DELETE_ERROR = 'QUICK_ACTION_DELETE_ERROR';
export const QUICK_ACTION_DELETE_REQUEST = 'QUICK_ACTION_DELETE_REQUEST';
export const QUICK_ACTION_DELETE_SUCCESS = 'QUICK_ACTION_DELETE_SUCCESS';

export const CREATE_UPLOAD_DOCUMENT_SUCCESS = 'CREATE_UPLOAD_DOCUMENT_SUCCESS';
export const CREATE_UPLOAD_DOCUMENT_ERROR = 'CREATE_UPLOAD_DOCUMENT_ERROR';
export const CREATE_UPLOAD_DOCUMENT_REQUEST = 'CREATE_UPLOAD_DOCUMENT_REQUEST';

export const CREATE_LIST_DOCUMENT_SUCCESS = 'CREATE_LIST_DOCUMENT_SUCCESS';
export const CREATE_LIST_DOCUMENT_ERROR = 'CREATE_LIST_DOCUMENT_ERROR';
export const CREATE_LIST_DOCUMENT_REQUEST = 'CREATE_LIST_DOCUMENT_REQUEST';

export const EDIT_LIST_DOCUMENT_SUCCESS = 'EDIT_LIST_DOCUMENT_SUCCESS';
export const EDIT_LIST_DOCUMENT_ERROR = 'EDIT_LIST_DOCUMENT_ERROR';
export const EDIT_LIST_DOCUMENT_REQUEST = 'EDIT_LIST_DOCUMENT_REQUEST';

export const DELETE_LIST_DOCUMENT_SUCCESS = 'DELETE_LIST_DOCUMENT_SUCCESS';
export const DELETE_LIST_DOCUMENT_ERROR = 'DELETE_LIST_DOCUMENT_ERROR';
export const DELETE_LIST_DOCUMENT_REQUEST = 'DELETE_LIST_DOCUMENT_REQUEST';

export const LIST_EDIT_VIDEO_GUIDE_SUCCESS = 'LIST_EDIT_VIDEO_GUIDE_SUCCESS';
export const LIST_EDIT_VIDEO_GUIDE_ERROR = 'LIST_EDIT_VIDEO_GUIDE_ERROR';
export const LIST_EDIT_VIDEO_GUIDE_REQUEST = 'LIST_EDIT_VIDEO_GUIDE_REQUEST';

export const RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_SUCCESS =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_SUCCESS';
export const RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_ERROR =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_ERROR';
export const RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_REQUEST =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_NAME_REQUEST';

export const SETTING_USER_ANALYTICS_ERROR = 'SETTING_USER_ANALYTICS_ERROR';
export const SETTING_USER_ANALYTICS_SUCCESS = 'SETTING_USER_ANALYTICS_SUCCESS';
export const SETTING_USER_ANALYTICS_REQUEST = 'SETTING_USER_ANALYTICS_REQUEST';

export const RUN_QUICK_ACTION_HISTORY_ACCESSS_SUCCESS =
    'RUN_QUICK_ACTION_HISTORY_ACCESSS_SUCCESS';
export const RUN_QUICK_ACTION_HISTORY_ACCESSS_ERROR =
    'RUN_QUICK_ACTION_HISTORY_ACCESSS_ERROR';
export const RUN_QUICK_ACTION_HISTORY_ACCESSS_REQUEST =
    'RUN_QUICK_ACTION_HISTORY_ACCESSS_REQUEST';

export const USER_PROFILE_MRA_SUCCESS = 'USER_PROFILE_MRA_SUCCESS';
export const USER_PROFILE_MRA_ERROR = 'USER_PROFILE_MRA_ERROR';
export const USER_PROFILE_MRA_REQUEST = 'USER_PROFILE_MRA_REQUEST';

export const SUPPORTING_DOCUMENT_TOKEN_ERROR =
    'SUPPORTING_DOCUMENT_TOKEN_ERROR';
export const SUPPORTING_DOCUMENT_TOKEN_REQUEST =
    'SUPPORTING_DOCUMENT_TOKEN_REQUEST';
export const SUPPORTING_DOCUMENT_TOKEN_SUCCESS =
    'SUPPORTING_DOCUMENT_TOKEN_SUCCESS';
export const CLEAR_DOCUMENTS_SUPPORTING_TOKEN_DATA =
    'CLEAR_DOCUMENTS_SUPPORTING_TOKEN_DATA';

export const SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR =
    'SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR';
export const SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS =
    'SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS';
export const SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS =
    'SETTINGS_WORKSPACE_ACCESS_TOKEN_REQUESTS';

export const SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR';
export const SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS';
export const SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_REQUEST =
    'SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_REQUEST';

export const SETTING_CLIENT_ANALYTICS_ERROR = 'SETTING_CLIENT_ANALYTICS_ERROR';
export const SETTING_CLIENT_ANALYTICS_SUCCESS =
    'SETTING_CLIENT_ANALYTICS_SUCCESS';
export const SETTING_CLIENT_ANALYTICS_REQUEST =
    'SETTING_CLIENT_ANALYTICS_REQUEST';

export const SETTING_OWNER_ANALYTICS_ERROR = 'SETTING_OWNER_ANALYTICS_ERROR';
export const SETTING_OWNER_ANALYTICS_SUCCESS =
    'SETTING_OWNER_ANALYTICS_SUCCESS';
export const SETTING_OWNER_ANALYTICS_REQUEST =
    'SETTING_OWNER_ANALYTICS_REQUEST';

export const SUPPORTING_DOCUMENT_USER_DELETE_ERROR =
    'SUPPORTING_DOCUMENT_USER_DELETE_ERROR';
export const SUPPORTING_DOCUMENT_USER_DELETE_REQUEST =
    'SUPPORTING_DOCUMENT_USER_DELETE_REQUEST';
export const SUPPORTING_DOCUMENT_USER_DELETE_SUCCESS =
    'SUPPORTING_DOCUMENT_USER_DELETE_SUCCESS';
export const CLEAR_DOCUMENTS_SUPPORTING_USER_DATA =
    'CLEAR_DOCUMENTS_SUPPORTING_USER_DATA';
export const WORKSPACES_ADMIN_CREATE_ERROR = 'WORKSPACES_ADMIN_CREATE_ERROR';
export const WORKSPACES_ADMIN_CREATE_SUCCESS =
    'WORKSPACES_ADMIN_CREATE_SUCCESS';
export const WORKSPACES_ADMIN_CREATE_REQUEST =
    'WORKSPACES_ADMIN_CREATE_REQUEST';

export const ENTERPRISE_CLIENT_LIST_ERROR = 'ENTERPRISE_CLIENT_LIST_ERROR';
export const ENTERPRISE_CLIENT_LIST_SUCCESS = 'ENTERPRISE_CLIENT_LIST_SUCCESS';
export const ENTERPRISE_CLIENT_LIST_REQUEST = 'ENTERPRISE_CLIENT_LIST_REQUEST';

export const PLAYCHAT_CONVERSATION_DOWNVOTE_REQUEST =
    'PLAYCHAT_CONVERSATION_DOWNVOTE_REQUEST';
export const PLAYCHAT_CONVERSATION_DOWNVOTE_SUCCESS =
    'PLAYCHAT_CONVERSATION_DOWNVOTE_SUCCESS';
export const PLAYCHAT_CONVERSATION_DOWNVOTE_ERROR =
    'PLAYCHAT_CONVERSATION_DOWNVOTE_ERROR';

export const STRIPE_MANAGED_CLIENT_LIST_SUCCESS =
    'STRIPE_MANAGED_CLIENT_LIST_ERROR';
export const STRIPE_MANAGED_CLIENT_LIST_ERROR =
    'STRIPE_MANAGED_CLIENT_LIST_ERROR';
export const STRIPE_MANAGED_CLIENT_LIST_REQUEST =
    'STRIPE_MANAGED_CLIENT_LIST_REQUEST';

export const RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_SUCCESS =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_SUCCESS';
export const RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_ERROR =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_ERROR';
export const RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_REQUEST =
    'RUN_QUICK_ACTION_OUTPUT_UPDATE_FEEDBACK_REQUEST';
export const RUN_QUICK_ACTION_REMOVE_FEEDBACK_SUCCESS =
    'RUN_QUICK_ACTION_REMOVE_FEEDBACK_SUCCESS';

export const RUN_QUICK_ACTION_REMOVE_TEXT_SUCCESS =
    'RUN_QUICK_ACTION_REMOVE_TEXT_SUCCESS';
export const RUN_QUICK_ACTION_UPLOAD_TEXT_ERROR =
    'RUN_QUICK_ACTION_UPLOAD_TEXT_ERROR';
export const RUN_QUICK_ACTION_UPLOAD_TEXT_REQUEST =
    'RUN_QUICK_ACTION_UPLOAD_TEXT_REQUEST';
export const RUN_QUICK_ACTION_UPLOAD_TEXT_SUCCESS =
    'RUN_QUICK_ACTION_UPLOAD_TEXT_SUCCESS';

export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_SUCCESS =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_SUCCESS';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_ERROR =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_ERROR';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_REQUEST =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_REQUEST';

export const POST_SAVE_EDIT_OUTPUT_HISTOTY_SUCCESS =
    'POST_SAVE_EDIT_OUTPUT_HISTOTY_SUCCESS';
export const POST_SAVE_EDIT_OUTPUT_HISTOTY_ERROR =
    'POST_SAVE_EDIT_OUTPUT_HISTOTY_ERROR';
export const POST_SAVE_EDIT_OUTPUT_HISTOTY_REQUEST =
    'POST_SAVE_EDIT_OUTPUT_HISTOTY_REQUEST';

export const RESTORE_EDIT_OUTPUT_HISTOTY_SUCCESS =
    'RESTORE_EDIT_OUTPUT_HISTOTY_SUCCESS';
export const RESTORE_EDIT_OUTPUT_HISTOTY_ERROR =
    'RESTORE_EDIT_OUTPUT_HISTOTY_ERROR';
export const RESTORE_EDIT_OUTPUT_HISTOTY_REQUEST =
    'RESTORE_EDIT_OUTPUT_HISTOTY_REQUEST';

export const RENAME_TITLE_EDIT_HISTORY_SUCCESS =
    'RENAME_TITLE_EDIT_HISTORY_SUCCESS';
export const RENAME_TITLE_EDIT_HISTORY_ERROR =
    'RENAME_TITLE_EDIT_HISTORY_ERROR';
export const RENAME_TITLE_EDIT_HISTORY_REQUEST =
    'RENAME_TITLE_EDIT_HISTORY_REQUEST';

export const GET_OUTPUT_HISTOTY_LIST_SUCCESS =
    'GET_OUTPUT_HISTOTY_LIST_SUCCESS';
export const GET_OUTPUT_HISTOTY_LIST_ERROR = 'GET_OUTPUT_HISTOTY_LIST_ERROR';
export const GET_OUTPUT_HISTOTY_LIST_REQUEST =
    'GET_OUTPUT_HISTOTY_LIST_REQUEST';

export const QUICK_ACTION_RUN_CHECK_SUCCESS = 'QUICK_ACTION_RUN_CHECK_SUCCESS';
export const QUICK_ACTION_RUN_CHECK_ERROR = 'QUICK_ACTION_RUN_CHECK_ERROR';
export const QUICK_ACTION_RUN_CHECK_REQUEST = 'QUICK_ACTION_RUN_CHECK_REQUEST';

export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_SUCCESS =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_SUCCESS';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_ERROR =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_ERROR';
export const WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_REQUEST =
    'WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_EDIT_REQUEST';
export const WORKSPACES_CUSTOM_LIST_SUCCESS = "WORKSPACES_CUSTOM_LIST_SUCCESS";
export const WORKSPACES_CUSTOM_LIST_ERROR = "WORKSPACES_CUSTOM_LIST_ERROR";
export const WORKSPACES_CUSTOM_LIST_REQUEST = "WORKSPACES_CUSTOM_LIST_REQUEST";